import { AxiosResponse } from "axios";
import { axiosInstanceWebsite } from "../instance";

export const getCreditPrice = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/payment/credit-price`
  );
  return response.data;
};

export const createCreditPurchaseLink = async (packs: number) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/payment/create-credit-purchase-link`,
    {
      packs: packs,
    }
  );
  return response.data;
};
